import ShapeType, { RATING_TYPE } from "shape-entities/types/shape";
import store from "store";
import { getRealSizeByElementId } from "shape-entities/render-text";
import { FormNameType, SizeType } from "app/types/model-types";
import { selectFormValues } from "app/reducers/form";
import { getTemplateSize } from "shape-edit/forms/helpers";
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers";
import { shouldAspectRatio } from "shape-entities/defaults";
import { getRatingShapeSize } from "template-edit/components/helper";

const { max, min, round, floor } = Math

export default function calcBackgroundSize(shape: ShapeType, newContent?: string): SizeType {
    if (shape.type === RATING_TYPE) {
        return getRatingShapeSize(shape.text_fontsize, shape.text_padding, shape.stroke_width)
    }

    let content = newContent ? newContent : shape.text_content

    //if random product has empty content, replace it with the element name
    if (content === undefined || content === '' || content === null || content.length === 0) {
        content = '%' + shape.text_xml_element + '%'
    }

    let autoWidth = shape.text_fontsize * content.length
    let autoHeight = shape.text_fontsize

    const state: any = store.getState()
    const isAlt: boolean = !!state.isAlt
    const formName: FormNameType = isAlt ? 'altTemplateForm' : 'templateForm'
    const form: TemplateOrAlternativeTemplateType = selectFormValues(state, formName)
    const templateSize = getTemplateSize(form)

    if (autoWidth > templateSize.width) {
        autoWidth = templateSize.width
    }

    if (autoHeight > templateSize.height) {
        autoHeight = templateSize.height
    }

    const { realWidth, realHeight } = getRealSizeByElementId(`shape_${shape.index}`, shape.width, shape.height)

    const isAspectRatio = shape.is_aspect_size_ratio || shouldAspectRatio(shape.type)

    const heightCoef = templateSize && realWidth > templateSize.width ? round(realWidth / templateSize.width) : 1

    const newWidth = templateSize && realWidth > templateSize.width ? templateSize.width : realWidth
    const newHeight = templateSize && realHeight > templateSize.height ? templateSize.height : (templateSize && templateSize.height && heightCoef * realHeight > templateSize.height ? templateSize.height : heightCoef * realHeight)

    const maxSize = max(newWidth, newHeight)

    return {
        width: isAspectRatio ? maxSize : newWidth,
        height: isAspectRatio ? maxSize : newHeight
    }
}